// extracted by mini-css-extract-plugin
export const container = "mailingList-module--container--3xXBk";
export const textContainer = "mailingList-module--textContainer--2Nh6N";
export const text = "mailingList-module--text--KW-Ey";
export const highlightedText = "mailingList-module--highlightedText--148yA";
export const smallPrintText = "mailingList-module--smallPrintText--23XVy";
export const signUpContainer = "mailingList-module--signUpContainer--3qyAQ";
export const mailingForm = "mailingList-module--mailingForm--1VtU1";
export const textInput = "mailingList-module--textInput--1A2eq";
export const submitBtn = "mailingList-module--submitBtn--2QffR";